<template>
  <div class="d-flex no-wrap absence-table-row" :class="rowClasses" :style="`height:${height}px`" :id="`abs_${absence.id}`">
    <div v-for="column in columns" :key="column.columnName" class="ws-col pa-1" :style="`${headerWidth(column)} !important`">
      <component
        :is="getType(column)"
        :column="column"
        :absence="absence"
        :isDisabled="isDisabled"
        :property="column.columnName"
        :isAssignedToDifferentView="isAssignedToDifferentView"
        @click="onClick(column)"
        @inlineChange="(args) => $emit('inlineChange', args)"
        @copyAction="(absence) => $emit('copyAction', absence)"
        @editAction="(absence) => $emit('editAction', absence)"
        @deleteAction="(absence) => $emit('deleteAction', absence)"
        @forwardAction="(absence) => $emit('forwardAction', absence)"
        @restoreAction="(absence) => $emit('restoreAction', absence)"
        @mailAction="(absence) => $emit('mailAction', absence)"
      ></component>
    </div>
  </div>
</template>
<script>
import AbsenceDuration from './absenceTableCells/AbsenceDuration.vue';
import AbsenceReason from './absenceTableCells/AbsenceReason.vue';
import TextCell from './absenceTableCells/TextCell.vue';
import Zueri9Clients from './absenceTableCells/Zueri9Clients.vue';
import Zueri9Reason from './absenceTableCells/Zueri9Reason.vue';
import Actions from './absenceTableCells/Actions.vue';
import FromTo from './absenceTableCells/FromTo.vue';
import Zueri9State from './absenceTableCells/Zueri9State.vue';
import ReportedAtTime from './absenceTableCells/ReportedAtTime.vue';
import Backup1Until from './absenceTableCells/Backup1Until.vue';
import Remark from './absenceTableCells/Remark.vue';
import DutyLineTrack from './absenceTableCells/DutyLineTrack.vue';
import DutyLineTrackZ9 from './absenceTableCells/DutyLineTrackZ9.vue';
import VbzNrResolverCell from './absenceTableCells/Zueri9VbzNr.vue';
import MultiLineTextCell from './absenceTableCells/MultiLineTextCell.vue';
import Zueri9ClientAndReason from './absenceTableCells/Zueri9ClientAndReason.vue';
import CheckboxCell from './absenceTableCells/CheckboxCell.vue';
import LineTrack from './absenceTableCells/LineTrack.vue';
import Zueri9VbzNr from './absenceTableCells/Zueri9VbzNr.vue';
import DispoState from './absenceTableCells/DispoState.vue';
import LastModified from '@/modules/customerVbzWorksheet/viewComponents/absences/absencesVirtualScroller/absenceTableCells/LastModified.vue';
import TextCellEdit from '@/modules/customerVbzWorksheet/viewComponents/absences/absencesVirtualScroller/absenceTableCells/TextCellEdit.vue';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import DutyCellWithDetailView from '@/modules/customerVbzWorksheet/viewComponents/absences/absencesVirtualScroller/absenceTableCells/DutyCellWithDetailView.vue';

const types = {
  isSelected: CheckboxCell,
  id: TextCell,
  clone: TextCell,
  assignedTo: TextCell,
  duty: DutyCellWithDetailView,
  absenceDurationId: AbsenceDuration,
  reasonId: AbsenceReason,
  crewReport: CheckboxCell,
  vbzNr: TextCell,
  zueri9VbzNr: Zueri9VbzNr,
  zueri9Client: Zueri9Clients,
  zueri9ClientAndReason: Zueri9ClientAndReason,

  zueri9Reason: Zueri9Reason,
  actions: Actions,
  supervisorReport: CheckboxCell,
  line: TextCell,
  lineP2: TextCell,
  fromTo: FromTo,
  fromTo2: FromTo,
  backup1: TextCellEdit,
  backup2: TextCellEdit,
  backup1_reported: CheckboxCell,
  backup2_reported: CheckboxCell,
  backup1_until: Backup1Until,
  remarks: MultiLineTextCell,
  zueri9State: Zueri9State,
  dispoState: DispoState,
  reportedAtTime: ReportedAtTime,
  lastModified: LastModified,
  disponent: TextCell,
  redakteur: TextCell,
  remarkId: Remark,
  dutyLineTrack: DutyLineTrack,
  dutyLineTrackZ9: DutyLineTrackZ9,
  dutyLineTrack2: DutyLineTrack,
  fromToTwoLines: LineTrack,
};
export default {
  name: 'AbsencesRow',
  components: {
    AbsenceDuration,
    AbsenceReason,
    CheckboxCell,
    DutyCellWithDetailView,
    TextCell,
    TextCellEdit,
    Zueri9Clients,
    Zueri9Reason,
    LastModified,
    Zueri9VbzNr,
    Zueri9ClientAndReason,
    VbzNrResolverCell,
    Actions,
    FromTo,
    Zueri9State,
    DispoState,
    ReportedAtTime,
    Backup1Until,
    Remark,
    MultiLineTextCell,
    DutyLineTrack,
    DutyLineTrackZ9,
    LineTrack,
  },
  mixins: [wsMixin],
  props: {
    columns: Array,
    absence: Object,
    isAssignedToDifferentView: Boolean,
    height: Number,
  },
  data() {
    return {
      displayDutyInPopup: false,
    };
  },
  methods: {
    getType(column) {
      let component = column.cell; //|| types[column.columnName];
      if (component === TextCellEdit && this.isAssignedToDifferentView && this.mx_isDispoView) {
        // avoid inline editiing in case of forwarded item
        component = TextCell;
      }
      return component;
    },
    headerWidth(column) {
      if (column.width) {
        return `width: ${column.width}px`;
      }
      return 'flex: 1';
    },
  },
  computed: {
    isDisabled() {
      // lock is an object and cannot be just checked for existence with this.absence.lock => if it is the first condition to evaluate to true, the object is returned instead of true ==> double negation avoids this
      return this.absence.deleted === true || !!this.absence.lock || this.isAssignedToDifferentView;
    },
    isCompletedInDispoView() {
      console.debug(`absence id=${this.absence.id} dispoView=${this.mx_isDispoView} dispoState=${this.absence.dispoState}`);
      return this.mx_isDispoView && this.absence.dispoState === 3; //3 is "disponiert"
    },
    isMarkedAsNew() {
      console.debug('_created=', this.absence._created);
      return this.mx_isDispoView && this.absence._created === true;
    },
    rowClasses() {
      return `${this.isCompletedInDispoView ? 'dispo-view-disponiert' : ''} ${this.isMarkedAsNew ? ' dispo-view-marked-as-new' : ''}`;
    },
  },
};
</script>

<style scoped>
.absence-table-row {
  width: 100%;
}
.theme--light .absence-table-row {
  border-bottom: 1px solid #d0d0d0;
}
.theme--dark .absence-table-row {
  border-bottom: 1px solid #505050;
}
.theme--light .dispo-view-disponiert {
  background: #d7f1e2;
}
.theme--dark .dispo-view-disponiert {
  background: #063005;
}
.theme--light .dispo-view-marked-as-new {
  background: #eab086;
}
.theme--dark .dispo-view-marked-as-new {
  background: #632c04;
}
.ws-col {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  justify-content: center;
}
.ws-col > div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ws-col > * {
  /**font-size: 14px;**/
  font-size: 0.9rem;
}

.theme--light .absence-table-row:hover {
  background: #e0e0e0;
}
.theme--dark .absence-table-row:hover {
  background: #373737;
}
</style>
